import { useCallback, useState } from 'react'

type UseToolTip = {
  tooltip: boolean
  openTooltip: () => void
}

const useTooltip = (): UseToolTip => {
  const [tooltip, setTooltip] = useState<boolean>(false)
  const openTooltip = useCallback(() => {
    setTooltip(true)
    setTimeout(() => setTooltip(false), 1000)
  }, [setTooltip])
  return {
    tooltip,
    openTooltip,
  }
}
export default useTooltip
